type BoundingRec = {
  isReady: boolean;
  top: number;
  left: number;
  right: number;
  bottom: number;
  width: number;
  height: number;
};

import { useEffect, useRef, useState } from 'react';

export function useBoundingBox() {
  const ref = useRef<HTMLDivElement>(null);
  const [rect, setRect] = useState<BoundingRec>({
    isReady: false,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: 0,
    height: 0,
  });

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new ResizeObserver(([entry]) => {
      if (entry) {
        const box = entry.target.getBoundingClientRect();
        setRect({
          isReady: true,
          top: box.top,
          left: box.left,
          right: box.right,
          bottom: box.bottom,
          width: box.width,
          height: box.height,
        });
      }
    });

    observer.observe(element);

    return () => observer.disconnect();
  }, []);

  return [ref, rect] as const;
}
